// @mui
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { Container, Typography, Box, Grid, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'

import useSettings from '../hooks/useSettings'
import Page from '../components/Page'
import axiosInstance from '../utils/axios'
import CampaignForm from '../components/CampaignForm'
import { BACKEND_API } from '../config'

function dateToDMY(date) {
  const d = date.getDate();
  const m = date.getMonth() + 1; // Month from 0 to 11
  const y = date.getFullYear();
  return `${d.toString().padStart(2, '0')}-${m.toString().padStart(2, '0')}-${y}`;
}

export default function FormPage() {
  const { themeStretch } = useSettings()
  const [rows, setRows] = useState([])

  const [open, setOpen] = React.useState(false);
  const [openCampaign, setOpenCampaign] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  /*
  Sample data:
  [
  {
    "id": 1,
    "name": "Red shoes",
    "budget": 2345,
    "start": "2025-08-12T12:31:33Z",
    "end": "2025-09-03T12:31:33Z",
    "client": 1
  }
]
  */

const fetchRows = async () => {
  const response = await axiosInstance.get(`campaigns.json`)
  setRows(response.data)
}

  useEffect(() => {
    fetchRows()
  }, [])

  const columns = [
    { field: 'name', headerName: 'Name', width: 150, editable: true },
    { field: 'budget', headerName: 'Budget', width: 150, editable: true, type: 'number' },
    { field: 'start', headerName: 'Start', width: 200, editable: true, type: 'date',
      valueGetter: (params) => {
        return params.row.start ? new Date(params.row.start) : null
      },
      valueFormatter: (params) => {
        // show date in yyyy-mm-dd format
        return params.value ? dateToDMY(new Date(params.value)) : null
      }
     },
    { field: 'end', headerName: 'End', width: 200, editable: true, type: 'date',
      valueGetter: (params) => {
        return params.row.end ? new Date(params.row.end) : null
      },
      valueFormatter: (params) => {
        return params.value ? dateToDMY(new Date(params.value)) : null
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 300,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div style={{ display: 'flex', gap: 10 }}>
          <Button
            onClick={() => handleDelete(params.id, params.row)}
          >
            Delete
          </Button>
          <Button
            onClick={() => handleEdit(params.id)}
          >
            Edit
          </Button>
        </div>

      )
    }
  ]

  const handleProcessRowUpdate = async (newRow, oldRow) => {
    // Only send changes if something actually changed
    if (JSON.stringify(newRow) !== JSON.stringify(oldRow)) {
      try {
        await axiosInstance.put(
          `campaigns/${newRow.id}/`,
          newRow
        )
        // Option A: Update state directly
        // return newRow

        // Option B: Refresh table from backend after save
        fetchRows()
        return newRow
      } catch (error) {
        console.error('Update failed:', error)
        // Roll back to old row if error
        return oldRow
      }
    }
    return newRow
  }

  const handleDelete = async (id, row) => {
    if (window.confirm(`Are you sure you want to delete the campaign '${row.name}'?`)) {
      try {
        await axiosInstance.delete(`campaigns/${id}/`)
        fetchRows()
      } catch (error) {
        console.error('Delete failed:', error)
      }
    }
  }

  const handleEdit = async (id) => {
    const response = await axiosInstance.get(`campaigns/${id}/`)
    setOpenCampaign(response.data)
    handleClickOpen()
  }

  const handleSubmitForm = (data) => {
    // PUT request to the backend if originalData is not null
    let axiosResponse;
    if (openCampaign) {
      axiosResponse = axiosInstance.put(`campaigns/${openCampaign.id}/`, data)
    } else {
      axiosResponse = axiosInstance.post(`campaigns/`, data)
    }

    axiosResponse.then((response) => {
      console.log(response)
      fetchRows()
      handleClose()
    })

  }
  return (
    <Page title="Campaigns">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Typography variant="h3" component="h1" paragraph>
          Dummy Page One
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs>
            <Card>
              <CardContent>
                <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                  Add Campaign
                </Button>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  processRowUpdate={handleProcessRowUpdate}
                  onRowUpdate={handleProcessRowUpdate}
                  autoHeight
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{openCampaign ? 'Edit campaign' : 'Add campaign'}</DialogTitle>
        <DialogContent>
          <CampaignForm originalData={openCampaign} onSubmitForm={handleSubmitForm} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}
